import React, { PureComponent } from 'react';
import AccountSummaryData from 'components/AccountSummary/AccountSummaryData';
import AddFundsModal from 'components/Modal/AddFundsModal';
import Widget from 'components/Widget';
import { addFunds } from 'services/api/account';
import { currencyFormat, dateFormat } from 'services/utils';
import AccountContext, { AccountContextInterface } from 'storage/AccountContext';
import { notify, withErrorNotification } from 'storage/NotificationsContext';
import PermissionEnum from '../../model/PermissionEnum';
import './accountSummary.scss';

class AccountSummary extends PureComponent<
  Pick<AccountContextInterface, 'refreshSelectedAccount' | 'selectedAccount'>,
  { addFundsModal: boolean }
> {
  state = {
    addFundsModal: false,
  };

  onAdd = withErrorNotification(async (amount, purchaseOrderNum) => {
    await addFunds(this.props.selectedAccount.id, amount, purchaseOrderNum);

    this.closeAddFunds();

    const message = `Invoice of amount ${currencyFormat(
      amount,
      this.props.selectedAccount.currency,
    )} has been raised successfully.`;
    notify.info(message);

    this.props.refreshSelectedAccount();
  });

  openAddFunds = () => this.setState({ addFundsModal: true });

  closeAddFunds = () => this.setState({ addFundsModal: false });

  showValue = (value: number): number | string =>
    this.props.selectedAccount.showCurrency ? currencyFormat(value, this.props.selectedAccount.currency) : value;

  render() {
    const { selectedAccount } = this.props;
    const { addFundsModal } = this.state;
    const { currency } = selectedAccount;
    const isReadOnlyAdmin = selectedAccount.permissions.includes(PermissionEnum.READ_ONLY_ADMIN);

    if (!selectedAccount.showAccountSummary) {
      return null;
    }

    return (
      <Widget
        className="accountSummary"
        title={`Account Summary ${dateFormat(selectedAccount.balancesActualFor, true)}`}
      >
        {selectedAccount.showTotalSpent ? (
          <AccountSummaryData
            note="Total amount of approved funding requests charged to this account."
            title="Total Spent:"
            value={this.showValue(selectedAccount.totalAllocated)}
          />
        ) : (
          <AccountSummaryData
            note="This is the account starting balance, minus all funding charges deducted. Note, that articles are not deducted from the available balance until the funding request is approved and the article is editorially accepted."
            title="Available Balance:"
            value={this.showValue(selectedAccount.totalAvailableAmount)}
          />
        )}
        <AccountSummaryData
          note="Total charges for articles for which funding has been requested but not yet approved."
          title="Pending Approval:"
          value={this.showValue(selectedAccount.totalPendingApprovals)}
        />
        <AccountSummaryData
          note="Total charges for articles for which funding requests have been approved but articles have not yet been accepted and therefore have not been deducted from the available balance."
          title="Under Review:"
          value={this.showValue(selectedAccount.totalInProcess)}
        />

        {!isReadOnlyAdmin && selectedAccount.advanceCash && (
          <div className="text-center" style={{ marginTop: '0.5em' }}>
            <button
              className="btn btn-secondary"
              data-seleniumid="accountSummary-addFunds"
              onClick={this.openAddFunds}
              type="button"
            >
              Add Funds
            </button>
          </div>
        )}

        {addFundsModal && (
          <AddFundsModal currency={selectedAccount.currency} onAdd={this.onAdd} onCancel={this.closeAddFunds} />
        )}
      </Widget>
    );
  }
}
export default AccountContext.withContext(['refreshSelectedAccount', 'selectedAccount'])(AccountSummary);
